"use client";

import { useTranslations } from 'next-intl';

/**
 * Pre-configured translation hook
 * Use this instead of importing useTranslations in every file
 * 
 * @example
 * const { common, errors } = useT();
 * return <button>{common('save')}</button>;
 */
export const useT = () => {
  const common = useTranslations('common');
  const errors = useTranslations('errors');
  const validation = useTranslations('validation');
  const auth = useTranslations('auth');
  const nav = useTranslations('nav');
  const connectAccount = useTranslations('connectAccount');
  const addAccount = useTranslations('addAccount');
  const buildProfile = useTranslations('buildProfile');
  const nicheSelection = useTranslations('nicheSelection');
  const keywordSuggestionCard = useTranslations('keywordSuggestionCard');
  const appealReview = useTranslations('appealReview');
  const waitlist = useTranslations('waitlist');
  const appealExpired = useTranslations('appealExpired');
  const dashboard = useTranslations('dashboard');
  const settingsBottomSheet = useTranslations('settingsBottomSheet');
  const earnings = useTranslations('earnings');
  const insights = useTranslations('insights');
  const postStudio = useTranslations('postStudio');
  const accountDrawer = useTranslations('accountDrawer');

  return {
    common,
    errors,
    validation,
    auth,
    nav,
    connectAccount,
    addAccount,
    buildProfile,
    nicheSelection,
    keywordSuggestionCard,
    appealReview,
    waitlist,
    appealExpired,
    dashboard,
    settingsBottomSheet,
    earnings,
    insights,
    postStudio,
    accountDrawer,
  };
};

export type TranslationNamespace = ReturnType<typeof useT>;
